import React, { useState, useEffect, useContext } from "react";
import DashboardLayout from "../../layoutcontainers/DashboardLayout";
import BASEURL from "../Utils/Baseurl";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { Card, Stack, CardHeader } from "@mui/material";
import MaterialTypography from "../../components/MaterialTypography";
import MaterialButton from "../../components/MaterialButton";
import MaterialDataGrid from "../../components/MaterialDataGrid";
import AddDesignation from "./components/AddDesignation";
import { useUserDetails } from "../../context/auth";
const Designation = () => {
  const navigate = useNavigate();
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const [designationList, setDesignationList] = useState([]);

  const { display, setdisplay, AccessData ,update, setupdate} = useUserDetails();

  useEffect(() => {
    onDesignationSubmit();
  }, []);

  const designationListTable = {
    columns: [
      {
        field: "departmentName",
        headerName: "Department Name",
        flex: 1,
        editable: false,
        disableColumnMenu: true,
        sortable: true,
      },
      {
        field: "designation",
        headerName: "Designation Name",
        flex: 1,
        disableColumnMenu: true,
        editable: false,
        sortable: true,
      },
    ],
    rows: designationList?.map((performance) => (
         
      {
          id:performance.id,
       
          designation: performance.designation 
          ? performance.designation.charAt(0).toUpperCase() + performance.designation.slice(1).toLowerCase() 
          : "",
        
          departmentName : performance.departmentName
      }
  )
)
  };

  console.log('designationList:',designationList);
  
  const handleNewDesignation = () => {
    setdisplay(false);
    setupdate(false)
    navigate("/designation/add-designation");
  };

  const onDesignationListClick = (e) => {
    console.log("onDesignationListClick:", e?.id, e);
    setdisplay(true);
    setupdate(false)
    if (e?.id) {
      navigate(`/designation/designation-details?id=${e?.id}`);
    }
  };

  const onDesignationSubmit = async () => {
    const query = `query{
      allDesignation{
        id
        departmentName
        designation
        lastUpdate
      }
    }`;

    try {
      setPageState({ ...pageState, loading: true });

      const response = await axios.post(
        BASEURL,
        {
          query: query,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      // Extract department data from the response
      const designationList = response.data.data.allDesignation;
      setDesignationList(designationList);
      setPageState({ ...pageState, loading: false, state: "success" });

      console.log("Response:", designationList);
    } catch (error) {
      console.error("ResponseError:", error);
      setPageState({
        ...pageState,
        loading: false,
        error: true,
        message: error.message,
      });
    }
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Designation list
                </MaterialTypography>
                {/* <MaterialTypography variant="caption" color="text">
                                List of designation that you can get details of designation.
                            </MaterialTypography> */}
              </Stack>
              {AccessData &&
                Array.isArray(AccessData) &&
                AccessData.some(
                  (item) =>
                    item.component === "AddDesignation" && item.can_access
                ) && (
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleNewDesignation()}
                  >
                    Designation
                  </MaterialButton>
                )}
            </Stack>
          }
        />
        <MaterialDataGrid
         customHeight={500}
          rows={designationListTable.rows}
          columns={designationListTable.columns}
          checkboxSelection={false}
          isSelectable={false}
          onRowClick={onDesignationListClick}
          loading={pageState.loading}
          localeText={{
            noRowsLabel: (
              <Stack
                direction="column"
                alignItems="center"
                justifyContent="center"
                spacing={1}
              >
                <MaterialTypography
                  variant="body2"
                  fontWeight="medium"
                  color="text"
                >
                  No designation found
                </MaterialTypography>
                <MaterialTypography variant="caption" color="text">
                  You have not yet added any designation details. Click on the
                  "Add designation" button to start adding designation details.
                </MaterialTypography>
              </Stack>
            ),
          }}
        />
      </Card>
    </DashboardLayout>
  );
};

export default Designation;
